module.exports = __webpack_public_path__ + "img/11.1b167a98.png";